import React from 'react'

import { Flex, Text } from '@driftt/dds'

interface MeetingAttendeesCellProps {
  participantNames: string[]
}

export default function MeetingAttendeesCell({
  participantNames,
}: MeetingAttendeesCellProps) {
  return (
    <Flex alignItems="center">
      <Text as="span" isPrivate>{`${participantNames.join(', ')}`}</Text>
    </Flex>
  )
}
